export default {"src":"/_next/static/media/x.5c023a7c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};